@if (!hideNavigation) {
  <div id="commonHeaderDiv">
    <!-- Common Header Navbar -->
    <nav
      class="navbar navbar-default hidden-print tw-flex tw-w-full tw-max-w-full tw-overflow-hidden"
      [class.tw-border-b]="isTemplateEditor"
      [class.tw-border-gray-200]="isTemplateEditor"
      [class.tw-mb-0]="isTemplateEditor"
      [class.common-header__template-editor]="isTemplateEditor"
      role="navigation"
    >
      <div
        class="common-header__content tw-flex tw-w-full tw-min-w-0 tw-flex-grow tw-items-center tw-justify-between"
      >
        <div
          class="common-header__primary tw-flex tw-flex-1 tw-min-w-0 tw-gap-[12.5px] tw-pl-5 tw-pr-2.5 tw-items-center"
        >
          <button
            mat-icon-button
            tabindex="0"
            class="navbar-brand text-center tw-cursor-pointer tw-m-0 tw-p-0"
            [class.lg:!tw-hidden]="!isScreenShareApp && !isTemplateEditor"
            id="mobileMenuButton"
            (click)="onMenuButtonClick()"
            [attr.aria-label]="
              isTemplateEditor ? 'Toggle navigation' : 'Open menu'
            "
          >
            <mat-icon svgIcon="menu" class="large medium"></mat-icon>
          </button>

          <div
            class="common-header__page-title"
            [class.tw-ml-2.5]="isTemplateEditor"
            [class.lg:!tw-ml-5]="!isScreenShareApp && !isTemplateEditor"
          >
            <page-title [iconOnly]="isTemplateEditor"></page-title>
          </div>
          @if (isTemplateEditor) {
            <template-editor-toolbar
              class="tw-flex tw-flex-1 tw-min-w-0 tw-items-center"
            ></template-editor-toolbar>
          }
        </div>

        @if (isTemplateEditor) {
          <div class="common-header__template-editor-auth">
            <auth-buttons></auth-buttons>
          </div>
        }

        <div
          class="tw-flex tw-flex-shrink-0 tw-items-center"
          [class.tw-hidden]="isTemplateEditor"
          [class.lg:!tw-flex]="isTemplateEditor"
        >
          <!-- Nav Links -->
          <div class="nav navbar-nav actions-nav lg:tw-gap-[2.5px]">
            <!-- Environment -->
            @if (ENV_NAME) {
              <div class="env-name-nav-item">
                <span class="env-name-label">{{ ENV_NAME }}</span>
              </div>
            }
            @if (!isScreenShareApp) {
              <!-- Help Widget -->
              <help-widget-button></help-widget-button>

              <!-- Appcues Launchpad -->
              <div id="appcues-launchpad"></div>
            }

            <!-- Auth -->
            <auth-buttons></auth-buttons>
          </div>
        </div>

        <!-- END Nav Links -->
      </div>
    </nav>
  </div>
}
@if (!cookieEnabled) {
  <div class="bg-warning text-center u_padding-sm">
    <small
      ><strong>Cookies Are Disabled.</strong> Rise Vision needs to use cookies
      to properly function. Please enable cookies in your web browser and
      refresh this page.</small
    >
  </div>
}
